var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearninglanguagesCuate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-94"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.11,
    y: 334.62,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.34,
    y: 348.73,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.63,
    y: 119.88,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.85,
    y: 133.99,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.14,
    y: 119.88,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.18,
    y: 348.73,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.41,
    y: 33.33,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.18,
    y: 47.44,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.11,
    y: 33.33,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.52,
    y: 90.33,
    width: 160.16,
    height: 6.88,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.81 124.27 300.57 124.27 298.07 97.2 306.81 97.2 306.81 124.27",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.4 124.27 426.64 124.27 429.14 97.2 420.4 97.2 420.4 124.27",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.07 97.21 306.81 97.21 306.81 106.53 298.93 106.53 298.07 97.21",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.14 97.21 428.28 106.53 420.4 106.53 420.4 97.21 429.14 97.21",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.52,49.07C334.41,58.7,327,69.87,325.2,81.94c0,.18.27.24.31.06a73.24,73.24,0,0,1,3.14-9.67c4.68-1.28,9.26-2.34,11.72-7s2.18-11,1.7-16.17C342,48.9,341.66,48.89,341.52,49.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.72,72.24A79.88,79.88,0,0,1,341.23,52s.08,0,0,.06a85.83,85.83,0,0,0-8.53,13.42c2.35-2.39,4.93-4.53,7.16-7.07,0,0,.11,0,.07.07-2.21,2.66-4.63,5.55-7.51,7.51q-1.17,2.14-2.35,4.29c.2-.11.4-.2.6-.3,0,0,.06,0,0,0-.22.11-.44.23-.67.33-.37.67-.74,1.35-1.13,2C328.87,72.53,328.66,72.39,328.72,72.24Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.1,69.74a41.36,41.36,0,0,0,5.45-3.64c.05,0,.12,0,.07.07a29.2,29.2,0,0,1-5.44,3.71C331.09,69.92,331,69.79,331.1,69.74Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.42,81.83c0,.14.26.14.26,0,0-4,0-8,.06-12,1-2,3.21-3.19,4.73-4.84a21.29,21.29,0,0,0,2.83-3.94,28.38,28.38,0,0,0,3.29-11c.42-4.25-1.19-18.28-3-17.79-.93.25-3.93,7.2-4.73,9.49A65.76,65.76,0,0,0,325,53.45,124.71,124.71,0,0,0,324.42,81.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.39,64.68l0,0a89.94,89.94,0,0,1,2.41-15c1.14-5.26,2.48-10.21,5.18-14.9a.08.08,0,0,1,.14.08A55.65,55.65,0,0,0,328,46.29c.19-.28.41-.55.59-.82.08-.1.25,0,.18.11a8.3,8.3,0,0,1-.85,1.19l0,0c-.93,3.75-1.6,7.59-2.17,11.43l.12-.15s.08,0,.06,0l-.22.38c-.29,1.95-.56,3.89-.83,5.81a27.31,27.31,0,0,0,8.09-10.75s0,0,0,0a22.31,22.31,0,0,1-8.17,11.13c-.08.52-.15,1-.22,1.56,0,.1-.19.08-.19,0,0-.46,0-.92,0-1.37C324.35,64.8,324.33,64.73,324.39,64.68Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,57.39a80.44,80.44,0,0,0,7.06-12.15c0-.05.1,0,.09,0a39.56,39.56,0,0,1-7,12.22C326.09,57.56,326,57.47,326,57.39Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.54,44.26c1.1-1.94,2.25-3.83,3.29-5.81,0-.05.1,0,.08,0a30.27,30.27,0,0,1-3.2,5.86A.1.1,0,0,1,329.54,44.26Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.11,45.11a0,0,0,1,1,0,0A0,0,0,0,1,329.11,45.11Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.47,71.64a40.35,40.35,0,0,1-.92,7.83l.12.86a37.51,37.51,0,0,0,1.4-8.73.28.28,0,0,0,0-.27h0a57.31,57.31,0,0,0-.88-11.83c-1.23-7.3-3.92-14.31-9-19.79a.36.36,0,0,0-.56.12c-2.06,5.23-1.34,11.46.41,16.68a30.22,30.22,0,0,0,4,7.92C318.83,66.88,321.05,69,322.47,71.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.79,42.15c4.83,7.83,8.19,17.13,8.6,26.38,0,.17-.27.21-.29,0-.12-.83-.24-1.65-.38-2.47h0a31.44,31.44,0,0,1-5.48-6.32s0-.09.07-.05a66.23,66.23,0,0,0,5.32,5.79c-.35-2.05-.76-4.06-1.24-6.05L320,59c-.08-.09.06-.24.15-.14l.11.13a68.39,68.39,0,0,0-2.52-8,24.11,24.11,0,0,1-3.5-4.5s0-.07.07,0a35.25,35.25,0,0,0,2.23,3c.32.37.68.72,1,1.09a60.92,60.92,0,0,0-4-8.24C313.54,42.14,313.72,42,313.79,42.15Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.77,51.82c1.56,2.1,3.34,4.1,4.79,6.27,0,.06-.05.13-.1.08a31.93,31.93,0,0,1-4.8-6.29A.06.06,0,0,1,314.77,51.82Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.78,58.58l.06.06a.05.05,0,0,1-.07.08l-.07-.07A.05.05,0,0,1,319.78,58.58Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.48,55.23a24.08,24.08,0,0,0,5.1,12,12.62,12.62,0,0,0,4.13,3.22c1.79.89,3.66,1.91,5.51,2.63A35.63,35.63,0,0,1,322.17,80l.18-.62c-1.18-10.2-7.79-18.93-16.24-24.53A.41.41,0,0,0,305.48,55.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.4,58.25c-.06,0,0-.16.09-.11A34.55,34.55,0,0,1,319.25,71.4c.06.14-.13.27-.21.13-.39-.69-.79-1.36-1.2-2h0a11.57,11.57,0,0,1-5.19-3s0-.09.06,0a11.52,11.52,0,0,0,2.44,1.71,26,26,0,0,0,2.45,1c-.72-1.13-1.46-2.22-2.24-3.28a22.5,22.5,0,0,1-5.8-3.25c-.05,0,0-.13.06-.1A55.89,55.89,0,0,0,315,65.38,48.18,48.18,0,0,0,311.2,61c-.65-.35-1.32-.7-1.95-1.07a0,0,0,0,1,0-.09,6.91,6.91,0,0,1,1.5.73C310,59.75,309.24,59,308.4,58.25Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.58,61.77a2.62,2.62,0,0,1,.32.23s0,.07,0,.06l-.33-.19C308.47,61.83,308.52,61.74,308.58,61.77Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.74 90.33 315.34 90.33 316.2 78.92 316.53 75.2 331.4 75.2 331.73 78.92 332.74 90.33",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.73 78.92 316.2 78.92 316.53 75.2 331.4 75.2 331.73 78.92",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.34,
    y: 72.15,
    width: 17.24,
    height: 3.81,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.1,
    y: 64.38,
    width: 41.41,
    height: 10.43,
    transform: "translate(439.4 -300.21) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.53,
    y: 43.74,
    width: 4.55,
    height: 10.43,
    transform: "translate(418.76 -320.85) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.96,
    y: 52.69,
    width: 1.69,
    height: 10.43,
    transform: "translate(427.71 -311.9) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.53,
    y: 77.38,
    width: 4.55,
    height: 10.43,
    transform: "translate(452.4 -287.21) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.51,
    y: 62.51,
    width: 48.3,
    height: 7.29,
    transform: "translate(444.81 -312.51) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.34,
    y: 53.64,
    width: 18.58,
    height: 4.37,
    transform: "translate(434.46 -322.8) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.33,
    y: 67.03,
    width: 48.3,
    height: 7.29,
    transform: "translate(169.38 -270.96) rotate(44.67)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.71,
    y: 70.95,
    width: 18.58,
    height: 4.37,
    transform: "translate(171.84 -272.02) rotate(44.67)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.14,
    y: 65.78,
    width: 36.69,
    height: 12.38,
    transform: "translate(460.45 -316.52) rotate(90)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.78,
    y: 78.52,
    width: 3.42,
    height: 12.38,
    transform: "translate(473.2 -303.78) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.82,
    y: 73.9,
    width: 1.33,
    height: 12.38,
    transform: "translate(468.58 -308.39) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.68,
    y: 68.52,
    width: 34.48,
    height: 8.55,
    transform: "translate(560.44 -223.7) rotate(113.23)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.59,
    y: 79.53,
    width: 3.21,
    height: 8.55,
    transform: "translate(563.96 -204.02) rotate(113.23)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.68,
    y: 60.69,
    width: 3.21,
    height: 8.55,
    transform: "translate(557.93 -237.72) rotate(113.23)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.92,
    y: 64.76,
    width: 1.25,
    height: 8.55,
    transform: "translate(559.23 -230.44) rotate(113.23)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.78,82V33.47h48.51V82Zm2.29-46.22V79.68H131V35.75Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.13,
    y: 46.46,
    width: 15.19,
    height: 34.24,
    transform: "translate(174.3 -47.14) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.62,
    y: 107.94,
    width: 11.47,
    height: 33.14,
    transform: "translate(200.71 249.01) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.79,
    y: 167.21,
    width: 14.41,
    height: 24.11,
    transform: "translate(-75.27 283.26) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.78,147.13V98.62h48.51v48.51Zm2.29-46.22v43.93H131V100.91Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.78,212.28v-48.5h48.51v48.5Zm2.29-46.21V210H131V166.07Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.26,
    y: 48.95,
    width: 17.54,
    height: 17.54,
    transform: "translate(166.75 -51.32) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.26,
    y: 114.1,
    width: 17.54,
    height: 17.54,
    transform: "translate(231.91 13.84) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.26,
    y: 179.26,
    width: 17.54,
    height: 17.54,
    transform: "translate(297.07 79) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-94"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 441.88,
    rx: 180.39,
    ry: 24.31,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-94"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "33.4 403.49 87.55 403.25 141.7 403.16 250 402.99 358.3 403.16 412.45 403.25 466.6 403.49 412.45 403.74 358.3 403.82 250 403.99 141.7 403.82 87.55 403.74 33.4 403.49",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.43,225.45s25-3.5,19.15-33.66C105.58,191.79,77.66,198.05,86.43,225.45Z",
    style: {
      fill: "#054B8B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.43,225.45s25-3.5,19.15-33.66C105.58,191.79,77.66,198.05,86.43,225.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7,219.16a47.78,47.78,0,0,1,1.7-4.5c0-.19,0-.39.06-.57,0-.42.08-.83.11-1.25.07-.9.12-1.8.18-2.7.1-1.8.22-3.61.25-5.41,0-.1.15-.09.15,0,0,1.81,0,3.61,0,5.42,0,.9-.08,1.8-.14,2.7,0,.2,0,.4,0,.6a54.38,54.38,0,0,1,5-8.57q1.29-1.8,2.74-3.46c1-1.14,2-2.23,3-3.36.07-.07.18,0,.11.12a44.3,44.3,0,0,0-4.82,6.4c-.76,1.15-1.47,2.33-2.16,3.53l.24-.09c.29-.13.59-.25.89-.36.67-.27,1.35-.52,2-.78,1.34-.49,2.68-1,4-1.49.08,0,.13.11,0,.14-1.33.53-2.64,1.09-4,1.66l-1.93.83-1,.4a2.73,2.73,0,0,1-.66.23c-.5.91-1,1.82-1.46,2.74a65.89,65.89,0,0,0-3.06,7.2l-.18.52a14.82,14.82,0,0,1,2-1l2.59-1.18c1.75-.8,3.49-1.62,5.17-2.57a.08.08,0,0,1,.08.14c-1.72.94-3.4,1.93-5.12,2.87-.86.46-1.73.92-2.61,1.35a8.69,8.69,0,0,1-2.35.94A29.62,29.62,0,0,0,87,226.75c-.27,3.41-.24,6.85-.32,10.27a0,0,0,0,1-.09,0c-.25-3.1-.39-6.23-.41-9.34A27.15,27.15,0,0,1,87.7,219.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55,201.41a29.63,29.63,0,0,1,.24,5.32,0,0,0,1,1-.07,0c-.1-1.76-.12-3.52-.32-5.28C91.39,201.35,91.53,201.32,91.55,201.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.69,202.92a20,20,0,0,0,3.22-1.57c.08-.06.15.08.07.13A12.29,12.29,0,0,1,98.73,203C98.67,203.05,98.63,203,98.69,202.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.64,273.35c0-2.76.07-5.52.1-8.29.05-9.17.13-18.34.29-27.51q.19-10.92.51-21.84a.11.11,0,0,1,.07-.09c0-2,0-4,0-6,0-.05.06-.07.12-.07s.12,0,.12.08l0,6a.11.11,0,0,1,.06.09c.37,13,.7,25.92.77,38.88,0,2.63,0,5.27,0,7.9q.14,12.67.09,25.35c0,1.35,0,2.69,0,4,0,7.73-.08,15.46-.08,23.19,0,.42-.46.62-1,.64s-1.16-.2-1.16-.68c0-8.52-.06-17.05-.06-25.57C85.62,284.1,85.6,278.72,85.64,273.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.07,265s12-8.91,23.43-2.89,13.2,29.21,13.2,29.21-16.75,2.4-27.3-7.64C95.23,274,96.07,265,96.07,265Z",
    style: {
      fill: "#054B8B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8,265.51a14.3,14.3,0,0,1,7-.91,9.14,9.14,0,0,1,1.47-.14l1.7-.13,3.5-.25c2.37-.18,4.75-.32,7.12-.56.08,0,.1.14,0,.15-2.35.3-4.68.63-7,.87-1.21.12-2.41.25-3.63.33L102,265c.36.08.72.16,1.07.26a28.6,28.6,0,0,1,5.45,2.22c1,.17,1.89.43,2.82.65,1.48.35,3,.73,4.44,1.12,2.92.77,5.81,1.63,8.71,2.47a.08.08,0,0,1,0,.15c-2.89-.71-5.8-1.36-8.7-2.05-1.41-.34-2.82-.67-4.23-1l-1.1-.25a35.35,35.35,0,0,1,8.54,7.43,46.17,46.17,0,0,1,5.94,9.36c0,.09-.08.17-.13.08A45.81,45.81,0,0,0,117.6,276c.06.16.11.32.16.48.22.71.44,1.42.67,2.12.44,1.42.89,2.83,1.32,4.26,0,.09-.12.12-.15,0-.51-1.37-1-2.75-1.47-4.13l-.72-2-.36-1.05c0-.11-.08-.22-.11-.33a42,42,0,0,0-4.27-3.63,32.27,32.27,0,0,0-6.38-3.66l.12.62.36,1.64c.23,1.14.45,2.28.68,3.42.45,2.33.73,4.68,1.17,7,0,.1-.13.13-.15,0-.54-2.34-1.24-4.64-1.76-7-.26-1.17-.52-2.34-.77-3.52l-.33-1.65c-.06-.3-.13-.61-.17-.92-.22-.09-.43-.19-.65-.27-3.16-1.17-6.64-2-10-1.37a9.84,9.84,0,0,0-7.24,5.8c-.11.26-.52.1-.46-.17C87.74,268.76,90.16,266.62,92.8,265.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.2,275.41c.34,1.53.68,3,1,4.57a33.86,33.86,0,0,1,.84,4.45c0,.06-.08.06-.09,0a34.21,34.21,0,0,1-1-4.48c-.29-1.5-.59-3-.88-4.51C111,275.35,111.18,275.32,111.2,275.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.82,279.29c1.53.77,3,1.65,4.62,2.29.1,0,0,.19-.07.14a49.68,49.68,0,0,1-4.58-2.38S122.79,279.27,122.82,279.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.37,248.6s14.69.94,21.53-8.75,5.3-23.52,5.3-23.52-15.44,1.88-21.56,8.83S93.37,248.6,93.37,248.6Z",
    style: {
      fill: "#054B8B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.48,263.1c.5-1.58,1.14-3.13,1.73-4.67s1.18-3,1.83-4.4a91.41,91.41,0,0,1,4.4-8.66c1-1.78,2.15-3.51,3.29-5.22,0-.26.08-.52.12-.79.06-.45.13-.91.2-1.36.15-.93.31-1.86.46-2.79.34-2,.76-4,1.08-6.07,0-.1.17-.09.16,0-.3,2-.5,4-.78,6-.14,1-.27,2-.42,3,0,.35-.11.71-.17,1.06a106.42,106.42,0,0,1,7.27-9.42c.35-.41.72-.8,1.07-1.2,0-.12.1-.23.14-.34.11-.28.22-.56.32-.84.22-.58.43-1.17.64-1.75.41-1.15.78-2.31,1.09-3.5a.08.08,0,0,1,.15.05c-.3,1.2-.61,2.41-1,3.6-.17.57-.36,1.14-.56,1.71,0,.09-.07.18-.1.28,1.88-2.05,3.83-4,5.81-6a.08.08,0,0,1,.11.11,105.28,105.28,0,0,0-10.41,12.75,10.2,10.2,0,0,1,1.09-.27c1.13-.22,2.27-.38,3.41-.53,2.39-.3,4.78-.61,7.16-1,.1,0,.14.13,0,.15-2.28.45-4.53,1-6.79,1.48-1.07.24-2.14.45-3.21.66a20.11,20.11,0,0,0-2.58.74c-.24.34-.49.67-.72,1-1.08,1.57-2.11,3.17-3.13,4.79l1.5-.29c1.14-.22,2.28-.43,3.42-.62,2.24-.37,4.48-.76,6.69-1.26.1,0,.14.13,0,.15-2.25.53-4.47,1.14-6.7,1.74-1.08.28-2.16.54-3.25.78l-1.63.36a4.53,4.53,0,0,1-.66.11q-3.23,5.22-6,10.68c-.82,1.6-1.6,3.21-2.37,4.83s-1.46,3.38-2.18,5.07C86.89,263.61,86.36,263.47,86.48,263.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.51,229.33c.28-1.4.58-2.8.89-4.19,0-.1.16,0,.15,0-.28,1.38-.55,2.76-.8,4.14a41.15,41.15,0,0,1-.83,4.12s0,0,0,0A30.12,30.12,0,0,1,101.51,229.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.08,228.93c.68-.34,1.4-.62,2.11-.89l1.12-.44.57-.23a2.84,2.84,0,0,0,.62-.27c.11-.08.18.11.07.13a2.89,2.89,0,0,0-.63.26l-.56.25-1.07.47a19.19,19.19,0,0,1-2.17.86A.08.08,0,0,1,110.08,228.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.33,237.05s-8.89-16.61-22.42-19.18-21.8,11.35-21.8,11.35S44,241.82,56.39,244,78.33,237.05,78.33,237.05Z",
    style: {
      fill: "#054B8B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.85,225.31a36.64,36.64,0,0,1,10.61.13l-.6-.32c-1-.51-2-1-3-1.55a70.28,70.28,0,0,0-6.35-3.1.08.08,0,1,1,.07-.14c2.11,1,4.3,1.81,6.43,2.79,1.06.49,2.1,1,3.14,1.54.66.36,1.4.69,2.06,1.11a37.38,37.38,0,0,1,8.59,2.86c-.56-.61-1.12-1.23-1.69-1.84-1.26-1.38-2.5-2.83-3.88-4.09-.07-.06,0-.17.11-.1,1.41,1.28,2.91,2.47,4.28,3.81.67.65,1.3,1.32,1.93,2,.31.35.62.7.91,1.07A35.6,35.6,0,0,1,87.58,254c0,.09-.11.14-.14.05A41,41,0,0,0,77.5,237.2a39.07,39.07,0,0,0-18.12-10.48,39.67,39.67,0,0,0-12.51-1.14A.14.14,0,0,1,46.85,225.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.11,229.22S44,241.82,56.39,244c9.47,1.67,17.26-3.26,20.42-5.69l.68-1.13s-6.4-5.4-18.51-8.51S34.11,229.22,34.11,229.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.71,219.39a34.63,34.63,0,0,1,3,2,19,19,0,0,1,2.61,2.38.08.08,0,0,1-.12.11c-.89-.78-1.8-1.56-2.73-2.3a30.09,30.09,0,0,0-2.84-2C54.54,219.47,54.62,219.34,54.71,219.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.28,222.2c.5.21,1,.39,1.52.6l1.5.63c.11,0,.06.22,0,.17L48.74,223c-.5-.2-1-.44-1.5-.64C47.15,222.31,47.19,222.17,47.28,222.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.11,258s-2.38,16.48-14.77,22.24-27.49,0-27.49,0S43.79,244.55,80.11,258Z",
    style: {
      fill: "#054B8B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.39,269.47c1.14-.13,2.28-.32,3.41-.53l1.66-.31.87-.18c.33-.31.66-.62,1-.93A50.55,50.55,0,0,1,60.91,262a43.17,43.17,0,0,1,4.54-2.33h-.23l-4.08.18c-2.72.12-5.44.18-8.15.36a.08.08,0,1,1,0-.15c2.73-.19,5.44-.49,8.16-.72l4-.36,2-.17.52-.06c.71-.26,1.42-.51,2.14-.74a19.31,19.31,0,0,1,10.49-.57c3.12.79,6.23,2.84,7,6.12,0,.11-.15.19-.2.08-1.16-2.75-4.21-4.13-7-4.7a16.77,16.77,0,0,0-5.61-.11,13.76,13.76,0,0,1-.63,2.49c-.34,1.16-.68,2.32-1,3.48-.7,2.31-1.48,4.6-2.16,6.92a.08.08,0,0,1-.15,0c.58-2.31,1.06-4.65,1.62-7l.84-3.41A19.39,19.39,0,0,1,73.7,259a31.38,31.38,0,0,0-3.22.75,47.78,47.78,0,0,0-5.61,2.06c-.18,1.18-.45,2.34-.72,3.5-.33,1.45-.71,2.89-1.17,4.31a.07.07,0,0,1-.14,0,2.56,2.56,0,0,0,0-.27h0c.27-1.35.57-2.69.86-4,.23-1.08.44-2.17.67-3.26-1.54.7-3.05,1.45-4.51,2.29,0,.34-.12.68-.16,1-.09.56-.2,1.12-.3,1.69-.23,1.27-.49,2.54-.79,3.79A61.48,61.48,0,0,1,56.54,278a.07.07,0,0,1,0,.09l-.07.08c-.06.07-.14,0-.13-.07.57-2.45,1.23-4.87,1.77-7.32.26-1.22.53-2.44.78-3.67.12-.61.23-1.23.35-1.85,0-.17.06-.36.09-.55a51.31,51.31,0,0,0-4.83,3.22,52.39,52.39,0,0,0-7.38,6.74c-.09.1-.27,0-.18-.15a45.85,45.85,0,0,1,3-3.6c.62-.67,1.27-1.31,1.93-1.94l-.21,0-1.74.27c-1.15.15-2.3.26-3.45.39C46.33,269.63,46.29,269.48,46.39,269.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.09,275.06h0c0-.14,0-.29.07-.43a4.77,4.77,0,0,0,.15-.54h0c.25-1.1.47-2.21.67-3.33,0-.07.13-.05.13,0a13.53,13.53,0,0,1-.94,4.31s-.1,0-.09,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.46,274.8a.08.08,0,0,1,.08-.07c.34-1.46.68-2.92,1-4.39.16-.77.32-1.55.47-2.32.08-.42.15-.83.23-1.25a3.5,3.5,0,0,1,.26-1.07.08.08,0,0,1,.14,0,7,7,0,0,1-.31,2.21c-.15.8-.31,1.61-.48,2.41-.36,1.62-.77,3.24-1.23,4.84a.08.08,0,0,1-.16,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.52,264.73c2.26-.31,4.52-.64,6.79-.91.09,0,.13.13,0,.14-2.25.34-4.52.62-6.79.92C47.46,264.89,47.42,264.74,47.52,264.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.45,219.31S94,186.06,58.3,172.6C58.3,172.6,48.4,216.37,86.45,219.31Z",
    style: {
      fill: "#054B8B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.74,200.45c-.13-.08-.26-.17-.38-.23-.68-.37-1.35-.75-2-1.13l-4.15-2.32c-2.72-1.52-5.42-3.11-8.16-4.6-.09,0,0-.18.08-.13,2.75,1.49,5.55,2.89,8.32,4.36l4.09,2.16,1.67.88c-1.19-2.26-2.46-4.47-3.86-6.61-1.87-2.84-3.91-5.56-6-8.21a.12.12,0,0,1,.17-.17,56.36,56.36,0,0,1,8.26,10.13c0-.12,0-.24,0-.35,0-.83-.06-1.65-.07-2.48,0-1.62,0-3.25,0-4.87,0-.1.15-.1.16,0,.06,1.6.26,3.19.35,4.79,0,.8.08,1.59.1,2.39,0,.43,0,.92,0,1.39.73,1.18,1.44,2.36,2.11,3.57a59.68,59.68,0,0,1,3.19,6.7c0-.83.09-1.66.14-2.49.1-1.82.33-3.63.4-5.45,0-.1.16-.1.16,0,0,1.82,0,3.64,0,5.47,0,.91-.06,1.82-.12,2.72l-.06,1a61.2,61.2,0,0,1,2.7,9.14,100,100,0,0,1,1.33,10,0,0,0,1,1,0,0,53.58,53.58,0,0,0-1.9-8.95q-.66-2.35-1.41-4.68c-1.49-.7-2.91-1.58-4.35-2.37s-3-1.64-4.48-2.46c-3-1.63-6-3.3-9-4.74-.09,0,0-.17.08-.13,3.11,1.41,6.25,2.75,9.31,4.29,1.52.76,3,1.58,4.51,2.42,1.24.7,2.51,1.4,3.7,2.2-.35-1-.71-2.06-1.11-3.08A88.74,88.74,0,0,0,78.74,200.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.75,192.85c0-.1.16-.1.16,0-.13,1.9-.2,3.8-.4,5.69a.09.09,0,0,1-.17,0C81.41,196.63,81.61,194.74,81.75,192.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.62,199.2c2.24.9,4.49,1.75,6.72,2.69.06,0,0,.12,0,.1-2.26-.85-4.49-1.77-6.73-2.64C64.49,199.31,64.53,199.16,64.62,199.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.23,183.86a59.65,59.65,0,0,1,6.35,3.41.09.09,0,0,1-.1.16c-2.07-1.21-4.18-2.37-6.34-3.44C61.06,184,61.14,183.82,61.23,183.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.76,
    y: 291.23,
    width: 51.53,
    height: 54.32,
    transform: "translate(175.06 636.78) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.21,
    y: 310.45,
    width: 2.64,
    height: 93.04,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 310.45,
    width: 2.64,
    height: 93.04,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.95,
    y: 310.45,
    width: 2.64,
    height: 93.04,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.81,
    y: 342.07,
    width: 55.71,
    height: 7.52,
    transform: "translate(175.34 691.66) rotate(180)",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sofa--inject-94"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.88,
    y: 233.97,
    width: 50.47,
    height: 132.43,
    style: {
      fill: "#054B8B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.88,
    y: 233.97,
    width: 50.47,
    height: 132.43,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.66,
    y: 233.97,
    width: 50.47,
    height: 132.43,
    style: {
      fill: "#054B8B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.66,
    y: 233.97,
    width: 50.47,
    height: 132.43,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.34,
    y: 140.75,
    width: 211.33,
    height: 225.65,
    style: {
      fill: "#054B8B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.34,
    y: 140.75,
    width: 211.33,
    height: 225.65,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 355.69,
    y: 233.97,
    width: 1.2,
    height: 132.42
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 143.74,
    y: 233.97,
    width: 1.2,
    height: 132.42
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M356.91,328H143.74V286.89H356.91ZM145,326.73H355.67V288.12H145Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.5,213.16a.84.84,0,0,0,0,1.67A.84.84,0,0,0,157.5,213.16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.93,315.41a.84.84,0,0,0,0,1.67A.84.84,0,0,0,158.93,315.41Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M216.05,299.44c0-.09-.09-.17-.13-.25a.38.38,0,0,0-.65,0,2,2,0,0,0-.13.25C214.66,300.43,216.52,300.43,216.05,299.44Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.62,317.51c0-.08-.08-.17-.13-.25a.38.38,0,0,0-.65,0c-.05.08-.09.17-.13.25C131.24,318.5,133.1,318.5,132.62,317.51Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.69,218.26a.64.64,0,0,0,0,1.28A.64.64,0,0,0,164.69,218.26Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.2,283.07a.64.64,0,0,0,0,1.27A.64.64,0,0,0,120.2,283.07Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M204,182.64a.89.89,0,0,0-1.25,0,1.25,1.25,0,0,0-.3,1.21,1,1,0,0,0,1.86,0A1.24,1.24,0,0,0,204,182.64Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M165.93,310.68a.89.89,0,0,0-1.25,0,1.23,1.23,0,0,0-.3,1.2,1,1,0,0,0,1.85,0A1.21,1.21,0,0,0,165.93,310.68Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M341.51,319.3a.84.84,0,0,0,0-1.68A.84.84,0,0,0,341.51,319.3Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M290.77,207.74a.84.84,0,0,0,0-1.67A.84.84,0,0,0,290.77,207.74Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M368.58,311.41c0,.08.08.17.13.25a.38.38,0,0,0,.65,0c.05-.08.09-.17.13-.25C370,310.42,368.11,310.42,368.58,311.41Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M265.27,261.06a.89.89,0,0,0,1.25,0,1.23,1.23,0,0,0,.3-1.21,1,1,0,0,0-1.85,0A1.26,1.26,0,0,0,265.27,261.06Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M145,328s53.22,10.38,105.3,10.38S355.66,328,355.66,328Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 93.88,
    y: 354.75,
    width: 312.24,
    height: 11.64,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.48 366.4 148.65 392.67 135.76 419.08 124.53 419.08 128.7 392.67 132.85 366.4 161.48 366.4",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.85 366.4 161.49 366.4 153.7 382.33 130.34 382.33 132.85 366.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.66 419.08 359.44 419.08 346.55 392.67 333.71 366.4 362.35 366.4 366.49 392.67 370.66 419.08",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.86 382.33 341.5 382.33 333.71 366.4 362.34 366.4 364.86 382.33",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.3,309.63c-.92-2.77-49.95-67.56-53.3-68.8-.38-.17-22.3,15.43-22.3,15.43-.9,1.21-42.56-7.6-42.56-7.6l-.42,50.26,75.89-1.61s10.25,6,19.63,10.93h0c5.77,3,10.88,5.6,12.34,6C366.4,315.2,374.23,312.38,373.3,309.63Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.61,314.23c-1.47-.38-6.57-2.94-12.33-6h0c-9.37-4.91-19.62-10.95-19.62-10.95l-16.89.37L287.28,255c5.81,1,10.14,1.64,10.43,1.26,0,0,21.9-15.6,22.29-15.43,3.35,1.24,52.38,66,53.3,68.79S366.4,315.21,362.61,314.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.74,309.71c-1-2.84-50.21-67.58-53.65-68.86-1.3-.5-12,6.13-22.39,15.41L329.51,298s29.34,15.55,33.26,16.55S374.71,312.55,373.74,309.71Z",
    style: {
      fill: "#054B8B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.45,310.75c-8.52-10.65-41.89-54.41-49.51-65.58-.06-.1,0-.14.07-.06,8.68,10.38,41.69,54.41,49.62,65.51C370.79,310.85,370.63,311,370.45,310.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.27,312.12a11,11,0,0,1-2.29-8.51,10.64,10.64,0,0,1,3.95-6.84c.07,0,.16.07.1.13A12.66,12.66,0,0,0,357.41,312,.09.09,0,0,1,357.27,312.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.18,300.54c-3.36-4.3-5.66-10.5-4.16-15.9.06-.21.35-.13.39.05a75,75,0,0,0,4.37,15.52A.35.35,0,0,1,333.18,300.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,302.9c-3.36-4.3-5.66-10.5-4.16-15.9.06-.21.35-.13.38.05a76.22,76.22,0,0,0,4.37,15.52A.34.34,0,0,1,337,302.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.9,305.26c-3.36-4.3-5.66-10.5-4.16-15.9.05-.21.35-.13.38.05a76.22,76.22,0,0,0,4.37,15.52A.34.34,0,0,1,340.9,305.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.76,307.62c-3.37-4.3-5.66-10.5-4.16-15.91,0-.2.35-.12.38.06a75.58,75.58,0,0,0,4.37,15.52A.34.34,0,0,1,344.76,307.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.74,255.77c-3.7-4.88,3.89-10.63,7.59-5.74S316.44,260.66,312.74,255.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.27,308.86c1.24-4.64.42-9.66.21-14.38a.67.67,0,0,0-.94-.52.15.15,0,0,0-.23,0,28.68,28.68,0,0,0-8.11,12.4c-.86,2.8-.53,6.92,3,7.73C328.47,314.82,330.54,311.57,331.27,308.86Zm-3.45,2.94c-5.05,3.16-4.67-3.86-3.95-5.9a31.74,31.74,0,0,1,1.72-3.81,85.81,85.81,0,0,1,4.58-7.35c0,2.33.12,4.64.17,7C330.4,304.47,330.61,310.06,327.82,311.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.8,280.6c-2.57,2.5-.72,6.2,1.45,8.16a28.63,28.63,0,0,0,13.34,6.44.14.14,0,0,0,.17-.15.67.67,0,0,0,.55-.93c-2.25-4.15-4.14-8.88-7.6-12.22C321.69,280,318.24,278.24,315.8,280.6Zm10.81,7.92c1.16,2,2.21,4.08,3.44,6.05a83.47,83.47,0,0,1-7.71-3.94,28.86,28.86,0,0,1-3.44-2.38c-1.67-1.37-5.62-7.19.34-7.09C322.53,281.22,325.23,286.12,326.61,288.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.84,233.25H218.78S183.15,216.13,154.45,223c-32.9,7.91-37.11,49.23-12.52,63.84,31.16,18.52,169.82,14.93,169.82,14.93l-30-50.8s-46.11-9.71-87.92-8.3l59,8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.77,254.28a.82.82,0,0,1-.06-.26l-.06-.22c0-.16-.08-.32-.13-.49a9,9,0,0,0-.35-1c-.12-.33-.27-.65-.42-1a7.07,7.07,0,0,0-.56-.9s-.05,0-.08,0a.1.1,0,0,0-.05,0s-.05,0-.08,0a.15.15,0,0,0-.07,0c-5.07-1-39.53-5.88-44.65-6.46s-10.35-1.07-15.53-1.5a307.23,307.23,0,0,0-31.09-1.12c-1,0-1.94.05-2.91.09-.21-.07-.43-.11-.64-.16-.5-.12-1-.24-1.5-.34-.93-.18-1.88-.32-2.82-.46-2-.3-3.93-.51-5.88-.87a.09.09,0,0,0,0,.18c2,.43,3.9,1,5.86,1.43.57.12,1.13.25,1.7.36-3.8.2-7.6.49-11.39.84a.1.1,0,0,0,0,.19c5.16-.31,10.36-.35,15.54-.26s10.26.2,15.39.5c10.38.59,20.74,1.52,31.08,2.6,5.8.61,40.93,5.74,46.75,6h.07c.05.13.1.27.16.4.16.31.32.63.5.93a9.68,9.68,0,0,0,.52.88c.09.14.18.28.28.42l.15.21a1.07,1.07,0,0,1,.15.22C283.64,254.48,283.84,254.4,283.77,254.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.94,298.71c-1.86-3-3.44-6.13-5.14-9.19s-3.41-6.14-5.12-9.21c-3.41-6.12-15.65-26.7-16.86-28.14-.08-.09-.23,0-.2.12.58,1.59,8.22,15.22,10,18.25,3.52,6.08,7.21,12,10.86,18,1,1.71,2.11,3.4,3.17,5.11s2.18,3.37,3.14,5.12C300.83,298.92,301,298.82,300.94,298.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.47,257.29c-3.06-.74-6.19-1.21-9.28-1.8s-6.2-1.17-9.3-1.74q-9.3-1.73-18.64-3.31c-12.4-2.08-24.86-3.82-37.39-5-7.07-.68-14.15-1.12-21.24-1.64-.15,0-.14.22,0,.23,12.61.57,25.21,2.28,37.7,4.07s24.72,3.73,37,5.81q5.22.88,10.44,1.79c3.53.61,7.06,1.36,10.61,1.81C273.55,257.51,273.61,257.32,273.47,257.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.71,474.94c-3-.3-77.26-33.68-79.29-36.75-.78-1.15,3.45-12.26,9-25.53,1.18-2.86,2.43-5.81,3.71-8.8,8.27-19.43,17.51-39.85,17.51-39.85l49.75,22.19-18.88,39.23-4.14,8.62s22.72,25.5,24.59,29.1S311.7,475.24,308.71,474.94Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.71,474.94c-3-.3-77.26-33.68-79.29-36.75-.94-1.41,5.5-17.51,12.66-34.33l48.38,21.57-4.14,8.62s22.72,25.5,24.59,29.1S311.7,475.24,308.71,474.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.71,474.94c-3-.3-77.26-33.68-79.29-36.75-.78-1.15,3.45-12.26,9-25.53l47.95,21.39s22.72,25.5,24.59,29.1S311.7,475.24,308.71,474.94Z",
    style: {
      fill: "#054B8B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,471.49c-12.31-5.9-62.54-28.55-75.16-33.44-.1,0-.13,0,0,.07,12.08,6.12,62.48,28.36,75.1,33.58C309.16,471.8,309.24,471.62,309,471.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.33,458.33a11,11,0,0,0-8.82-.3,10.64,10.64,0,0,0-5.77,5.39c0,.08.11.14.15.07a12.69,12.69,0,0,1,14.37-5A.09.09,0,0,0,307.33,458.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.59,437.46c-4.95-2.31-11.52-3.15-16.45-.46-.19.1,0,.37.15.36a75.57,75.57,0,0,1,16.11.75A.34.34,0,0,0,290.59,437.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.77,440.69c-5-2.31-11.52-3.15-16.45-.46-.19.1,0,.37.14.36a75.66,75.66,0,0,1,16.12.75A.34.34,0,0,0,293.77,440.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.94,443.92c-4.95-2.31-11.52-3.15-16.45-.47-.19.11,0,.38.14.37a75.66,75.66,0,0,1,16.12.75A.34.34,0,0,0,296.94,443.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.11,447.15c-4.95-2.31-11.52-3.15-16.45-.47-.19.11,0,.38.15.37a75.6,75.6,0,0,1,16.11.75A.34.34,0,0,0,300.11,447.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.31,427.65c-5.6-2.5-9.49,6.2-3.88,8.7S247.92,430.15,242.31,427.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,426.58c-1.59-3.22-5.68-2.61-8.21-1.13a28.63,28.63,0,0,0-10.26,10.7.15.15,0,0,0,.09.22c-.05.4.23.89.72.8,4.65-.86,9.73-1.2,14-3.46C300.76,432.39,303.45,429.63,302,426.58Zm-10.88,7.85c-2.28.47-4.56.84-6.82,1.4a84.27,84.27,0,0,1,6.13-6.12,30.57,30.57,0,0,1,3.33-2.55c1.82-1.16,8.58-3.12,6.64,2.52C299.29,432.8,293.8,433.86,291.08,434.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.28,432.44c4,2.61,9.07,3.39,13.63,4.64.47.13.8-.33.78-.74a.14.14,0,0,0,.11-.2,28.69,28.69,0,0,0-9.3-11.55c-2.4-1.68-6.43-2.65-8.28.43C265.47,427.93,267.92,430.91,270.28,432.44Zm-1.74-4.19c-1.45-5.79,5.12-3.25,6.84-1.94a30.57,30.57,0,0,1,3.1,2.82,83.82,83.82,0,0,1,5.58,6.62c-2.2-.75-4.45-1.31-6.68-2C274.73,433,269.34,431.44,268.54,428.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.21,399.3l56,25.3s66.61-127.84,68.35-167c1.48-33.3-21.7-46.15-96.65-24.61l-18.36.23v12.67c8.06,1.06,29.56,4.44,29.56,4.44,15.64,5.9,20.68,8.34,20.43,8.85C263.48,338,243.21,399.3,243.21,399.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.66,245.16c-2.26,3-4.35,6.14-6.35,9.34-12-5.35-25.11-8.44-38.13-10.05q-5.52-.67-11.09-1c-.15,0-.14.23,0,.24a167.55,167.55,0,0,1,38.79,7.38c3.49,1.08,6.9,2.32,10.34,3.55-2.4,3.84-4.67,7.78-6.84,11.74a233.3,233.3,0,0,0-10.94,22.84c-1.8,4.32-3.55,8.67-5.1,13.09,0,.13.17.21.22.09q10.26-22.87,22.39-44.76c2.28-4.12,4.66-8.18,6.89-12.33C311.92,245.18,311.74,245,311.66,245.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.39,411.07c-3.27-1.27-6.43-2.86-9.62-4.3l-9.61-4.31c-6.4-2.86-28.52-12-30.35-12.46-.12,0-.18.15-.09.21,1.42.93,15.69,7.28,18.92,8.66,6.46,2.77,13,5.33,19.49,8,1.86.75,3.73,1.46,5.6,2.19s3.76,1.4,5.59,2.23C300.43,411.3,300.5,411.11,300.39,411.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.38,250.93c-4.41,8.39-8.17,17.17-12,25.84s-7.53,17.31-11.14,26q-10.77,26.06-20.06,52.7c-3.52,10-6.81,20.16-10,30.3-.05.15.18.2.23.06,5.93-17.94,12.35-35.72,19.05-53.38s13.8-35.08,21.32-52.37q3.17-7.28,6.43-14.51c2.18-4.83,4.45-9.63,6.49-14.51C311.76,250.9,311.49,250.73,311.38,250.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.08,232.19c1.23,1.3,79,3.08,79.4,2.59,1.06-1.34-9-50.7-17.11-69.57C269,141,263.09,138.85,259.6,137.41c-4.46-1.84-12.58-1.41-14.54-.59-2.23.91-11.88,11.74-14.78,20.49C224.47,174.9,216,231.05,217.08,232.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.94,141.72H239.89c.48-.56,1-1.09,1.4-1.57h23C264.8,140.59,265.35,141.11,265.94,141.72Zm3.28,4.1H236.64l-1.11,1.56h34.74Q269.73,146.56,269.22,145.82Zm3.51,5.66H233c-.3.52-.58,1-.85,1.56h41.47Zm2.95,5.67H230.34l-.06.16c-.15.44-.29.91-.44,1.4h46.59C276.18,158.17,275.93,157.66,275.68,157.15Zm2.64,5.66H228.69c-.13.5-.27,1-.4,1.56H279Zm2.36,5.66H227.3c-.11.52-.23,1-.35,1.57h54.31C281.07,169.5,280.87,169,280.68,168.47Zm2,5.67h-56.6q-.18.78-.33,1.56h57.44Zm1.77,5.66H224.91c-.1.52-.21,1-.31,1.56h60.31C284.75,180.83,284.6,180.31,284.44,179.8Zm1.63,5.67H223.82c-.1.52-.19,1-.29,1.56h63C286.36,186.51,286.22,186,286.07,185.47Zm1.53,5.66H222.79c-.1.52-.19,1-.28,1.56H288C287.87,192.17,287.74,191.65,287.6,191.13Zm1.45,5.66H221.8l-.27,1.57h67.9C289.3,197.84,289.17,197.31,289.05,196.79Zm1.37,5.67H220.85c-.08.52-.17,1-.25,1.56h70.18Zm1.3,5.66H220l-.24,1.56h72.36C292,209.16,291.84,208.64,291.72,208.12Zm1.25,5.66H219.09c-.08.53-.15,1.06-.23,1.57H293.3Zm1.18,5.67H218.29q-.12.81-.21,1.56h76.37C294.36,220.5,294.25,220,294.15,219.45Zm1.09,5.66H217.55c-.06.55-.12,1.08-.17,1.57h78.14C295.43,226.18,295.34,225.65,295.24,225.11Zm1,5.67H217a3.45,3.45,0,0,0,.07,1.41,1.17,1.17,0,0,0,.47.15H296.4C296.35,231.88,296.28,231.36,296.2,230.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.49,144c33.54,25.2,62.54,60.18,59.76,71.26-2.95,11.71-26.13,24.81-46.61,27.48-4.19.55-17.16-30.2-12.87-31.61,3.35-1.1,18.57-5.43,20.39-7.51,1.26-1.45-22.35-34.67-30-52C255.08,133.41,263.51,137.21,272.49,144Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.42,210.16s-12.8,1.28-21.13,2.52c-4.65.69-12.51,2.58-15.69,4.65-4.76,3.09-22.7,19.07-18.92,23.5,3.42,4,8.59-2.34,8.59-2.34s-6.3,6.41-1.68,9.35,10.58-6,10.58-6-7.16,6.34-1.93,9c4.54,2.31,12.48-7.23,12.48-7.23s-8.25,5.84-3.83,8.66c4.88,3.12,18.58-9.68,18.58-9.68,10.95,1.22,17.7.47,25.42-1.69C295.3,240.54,281.42,210.16,281.42,210.16Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.25,244c.49-.68,1-1.35,1.5-2a42.22,42.22,0,0,1,3.06-3.84c1.09-1.17,2.23-2.29,3.4-3.38s2.61-2.17,3.81-3.35a.1.1,0,1,1,.13.14,43.79,43.79,0,0,0-3.42,3.65c-1.09,1.22-2.16,2.45-3.24,3.68s-2.17,2.33-3.26,3.5c-.54.59-1,1.2-1.57,1.8a13.6,13.6,0,0,1-1.5,1.71.08.08,0,0,1-.11-.09A10.18,10.18,0,0,1,241.25,244Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,239.85a66.6,66.6,0,0,1,5.53-7.25,45.84,45.84,0,0,1,6.75-6.16c.09-.06.2.06.13.14-2,2.28-4.11,4.52-6.18,6.77-1,1.1-5.45,6.23-6,6.71C233.1,240.18,232.92,240,233,239.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.91,248.13a64.56,64.56,0,0,1,5.32-6.73A59.67,59.67,0,0,1,261.1,236c.09,0,.21.06.13.14-2.15,2-4.32,3.92-6.36,6-1,1-4.74,5.3-5.78,6.19C249,248.37,248.85,248.24,248.91,248.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.78,175l-25.54,16.56s-18.95-29.34-23.86-43.24.81-13.93,14.22-3.86S309.78,175,309.78,175Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.72,141.72h-12a7.7,7.7,0,0,1,0-1.57h9.61C269,140.61,269.86,141.14,270.72,141.72Zm5.62,4.1H259.56c.14.5.3,1,.49,1.56h18.28Zm7,5.66H261.61c.21.5.44,1,.68,1.56h22.9C284.57,152.51,284,152,283.33,151.48Zm6.65,5.67H264.24l.78,1.56h26.75Zm6.43,5.66H267.15c.28.51.56,1,.85,1.56h30.14Zm6.27,5.66H270.27l.89,1.57h33.23Zm6.15,5.67H273.54c.31.53.61,1.05.92,1.56h34.29l1-.67Zm-31.92,5.66.94,1.56H300l2.4-1.56Zm3.47,5.67,1,1.56h9.92l2.41-1.56Zm3.57,5.66.29.46.71-.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,171.37c-9.74,7.75-19.36,13-21.27,14.35-.09.06-.17-.09-.08-.15,1.94-1.18,12.35-8.84,21.25-14.36C304,171.14,304.07,171.3,304,171.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.88,190.46a12.81,12.81,0,0,0-1.55.8c-2.84-4.9-5.9-9.86-8.79-14.74l-4.24-7.16c-1.46-2.49-2.8-5.09-4.4-7.49a.06.06,0,0,0-.11.06,76.2,76.2,0,0,0,3.48,6.94c-.26-.34-.51-.7-.79-1-.63-.75-1.25-1.5-1.81-2.3-.09-.12-.3,0-.21.12.54.76,1,1.55,1.51,2.35s1,1.56,1.55,2.33,1.09,1.44,1.66,2.13a2.56,2.56,0,0,0,.2.26c.78,1.43,1.54,2.86,2.35,4.27,2.84,4.93,9.29,14.86,9.38,14.83a13.18,13.18,0,0,0,1.85-1.23C286,190.54,286,190.44,285.88,190.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.47,143c-27.22,14.14-52.78,31.34-57.58,43.29-3,7.52.71,21.15,3.74,29.34,1.48,4,39.13-11.54,36-14.85-7.74-8.18-9-11.46-8.15-13.12.53-1.06,30.32-26.92,38.68-38.58C254.82,132.84,242.38,136.81,230.47,143Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.86,237.71c-3.56,2-7.74-7.19-7.74-7.19a7.5,7.5,0,0,1-2.1,4.67c-2.26,2.12-6.57-.5-6.57-.5a9.31,9.31,0,0,1-3,4.57c-2.37,1.81-7.1-.2-7.1-.2a8.11,8.11,0,0,1-5.17,2.35c-5.22.16-9.65-6.47-12.52-10.65s-7.06-18.75-8.14-21.44l26.71-18.61s18.18,15.12,20.85,20.52C224.32,215.78,232.29,234.66,226.86,237.71Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.18,230.39C218,225,215.43,219.88,213,215c-.06-.11-.23,0-.17.08,2.53,4.85,3.82,10.49,6.16,15.42A.13.13,0,0,0,219.18,230.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.74,234.36a14.64,14.64,0,0,0-1.65-3.4c-.67-1.16-1.35-2.31-2.05-3.46-1.41-2.28-2.87-4.53-4.4-6.74-.07-.1-.23,0-.17.09,1.4,2.28,2.77,4.58,4.07,6.91.65,1.17,1.29,2.35,1.93,3.52a17.14,17.14,0,0,0,1.94,3.25A.19.19,0,0,0,210.74,234.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.29,239a10.17,10.17,0,0,0-1.64-3c-.67-1-1.32-2.06-2-3.09-1.31-2.07-2.61-4.14-3.84-6.25a.1.1,0,0,0-.17.09c1.24,2.15,2.45,4.32,3.71,6.46.62,1,1.24,2.1,1.87,3.15a9.34,9.34,0,0,0,1.94,2.7C200.24,239.06,200.31,239,200.29,239Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.15,164.19l19.93,19.55s26.21-23.21,33.8-35.85,2-13.82-13.17-6.62S191.15,164.19,191.15,164.19Z",
    style: {
      fill: "#054B8B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.15,164.19l19.93,19.55s26.21-23.21,33.8-35.85,2-13.82-13.17-6.62S191.15,164.19,191.15,164.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.2,140.15a8.36,8.36,0,0,1-.35,1.57H230.78l.93-.45c.84-.4,1.65-.77,2.43-1.12Zm-25.41,5.67-2.88,1.56h25.27c.32-.54.62-1.07.89-1.56Zm-10.2,5.66L209.86,153h31.41c.41-.53.8-1,1.18-1.56Zm-9.77,5.67-2.61,1.56H236.5c.46-.52.92-1,1.36-1.56Zm-9.42,5.66-2.25,1.38.18.18h39.92l1.48-1.56Zm2.11,5.66,1.6,1.57h28.55l1.57-1.57Zm5.78,5.67,1.59,1.56H219.8l1.65-1.56Zm5.77,5.66,1.59,1.56h5.07l1.7-1.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.22,178.63c-9.2-7.82-16-15.95-17.58-17.51-.07-.08.06-.19.13-.11,1.48,1.62,10.71,10.09,17.6,17.5C215.45,178.6,215.31,178.71,215.22,178.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.85,152.64c-1,2.14-2,4.27-2.85,6.47,0-.15,0-.29,0-.44a28.33,28.33,0,0,1,.61-4c0-.15-.19-.22-.23-.07-.3,1.33-.57,2.68-.78,4-.11.65-.17,1.3-.22,1.95a2.12,2.12,0,0,1,0,.24.19.19,0,0,0,0,.08c-1,2.93-1.58,5.93-2.41,8.89a.11.11,0,1,0,.22.06c.82-2.9,2-5.71,3-8.54s1.86-5.72,2.84-8.57C233.06,152.62,232.89,152.54,232.85,152.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.87,150.31c4.38,1.2,12.21-5.26,15.4-10.62.22-.37-.21-4.34-.5-9.19-.17-3-.29-6.23-.18-9.23,0-.62-19,3.88-19,3.88a48,48,0,0,1,1.4,11.6,7.61,7.61,0,0,1-.18,1.22,1.18,1.18,0,0,0,0,.21C243.31,140.5,242.64,149.14,246.87,150.31Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.43,121.3c-1.06,5-4.67,17.2-14.73,17a10.31,10.31,0,0,1-1.92-.17,1.05,1.05,0,0,1,0-.21,7.61,7.61,0,0,0,.18-1.22,48.16,48.16,0,0,0-1.4-11.61S256.32,121.9,260.43,121.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.44,110.75c.09,4.61-3.12,8.42-7.17,8.49s-7.4-3.59-7.49-8.21,3.12-8.42,7.17-8.5S241.35,106.13,241.44,110.75Z",
    style: {
      fill: "#054B8B"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 235.67,
    cy: 111.15,
    rx: 8.16,
    ry: 9.3,
    transform: "translate(-2.1 4.56) rotate(-1.1)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.62,96.33c3.11,6.26,2.81,25.88-1.17,30.91-5.77,7.29-16.8,9.73-23.4,2.44-6.39-7.08-5.54-32.64-.94-37.37C241.87,85.34,256,87.09,260.62,96.33Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.16,113.38s.1.06.1.12c-.06,1.32.1,2.84,1.29,3.29,0,0,0,.08,0,.08C245.09,116.65,244.9,114.62,245.16,113.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.36,112c2.12-.14,2.24,4.13.27,4.26S244.57,112.13,246.36,112Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.77,113.63s-.11.07-.1.12c.08,1.32-.06,2.84-1.24,3.32,0,0,0,.08,0,.07C237.9,116.89,238.05,114.87,237.77,113.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.55,112.28c-2.13-.1-2.18,4.17-.21,4.26S238.33,112.37,236.55,112.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.23,108.58a14.54,14.54,0,0,1-1.74-.23,2.86,2.86,0,0,1-1.73-.58.89.89,0,0,1-.08-1.09,2.24,2.24,0,0,1,2.16-.69,3.25,3.25,0,0,1,2.15,1A1,1,0,0,1,248.23,108.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.5,109.23c.59-.12,1.11-.32,1.68-.49a2.85,2.85,0,0,0,1.62-.83.9.9,0,0,0-.08-1.1,2.22,2.22,0,0,0-2.24-.35,3.27,3.27,0,0,0-2,1.31A1,1,0,0,0,234.5,109.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.72,125.6c-.31.31-.62.75-1.09.8a3.52,3.52,0,0,1-1.43-.29s-.09,0-.06.07a1.79,1.79,0,0,0,1.7.67,1.41,1.41,0,0,0,1-1.2C247.86,125.57,247.76,125.55,247.72,125.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.21,121.68a4.5,4.5,0,0,1-2.94,2.09,5.85,5.85,0,0,1-1.62.12,1.55,1.55,0,0,1-.31,0l-.29,0a.32.32,0,0,1-.27-.29h0a.66.66,0,0,1,0-.14h0v-.12c-.05-1,0-2.56,0-2.56-.36.19-2.23,1.1-2.22.57.14-4.41.29-9.31,1.36-13.67a.12.12,0,0,1,.24,0c0,4.24-.67,8.46-.71,12.72a7.68,7.68,0,0,1,2.11-.7c.14,0-.16,3-.1,3.44a.18.18,0,0,0,0,0,6.23,6.23,0,0,0,4.62-1.58C246.18,121.49,246.29,121.57,246.21,121.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.24,123.35a5.34,5.34,0,0,0,2.18,1.6,2.41,2.41,0,0,0,1.46,0c1.05-.31,1.05-1.28.83-2.1a6,6,0,0,0-.51-1.26A6.89,6.89,0,0,1,242.24,123.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.42,125a2.41,2.41,0,0,0,1.46,0c1.05-.31,1.05-1.28.83-2.1A2.49,2.49,0,0,0,244.42,125Z",
    style: {
      fill: "#ff98b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.71,110.25c-1.28-.24-4.24-4.67-5.51-6.43s-1.77-11.06-1.84-13.16a13.92,13.92,0,0,1,5.26,5.67C262,99.13,262.71,104.6,262.71,110.25Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.21,97.89a6.66,6.66,0,0,0,6.08,2.22A6.77,6.77,0,0,0,250.48,96c0-.06.12,0,.1,0a6.7,6.7,0,0,1-5.2,4.57,6.84,6.84,0,0,1-6.3-2.64C239,97.91,239.14,97.81,239.21,97.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,81.45c3.85.07,7.39,2.18,8.82,4.79a7.47,7.47,0,0,1,.75,4.85c0,.07-.15.06-.14,0a8.19,8.19,0,0,0-3.9-7.37,10.53,10.53,0,0,0-9.34-1.07,6.74,6.74,0,0,0-3.57,2.9c-.07.14-.36,0-.3-.1C239.34,83,242.5,81.4,246,81.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.68,89.93a8.45,8.45,0,0,1,3.59-4.59c2.35-1.47,5-1.27,7.67-1,.08,0,.07.12,0,.11-2.26-.21-4.56-.29-6.63.79a8.28,8.28,0,0,0-3.84,4.08,8.13,8.13,0,0,0,3.43,10.08,8.25,8.25,0,0,0,6.52.63c.08,0,.14.09.06.13a8.3,8.3,0,0,1-10.8-10.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.92,100.15s3.58-6.92.49-10.88c-1.76-2.24-7.5-1.88-7.5-1.88a10.38,10.38,0,0,0-6.66-4.33c-4.82-1-10.51,1.82-10.51,1.82s-4.59-2.57-8.84-.08c-5.93,3.47-5.09,12.55.94,15.41,4.24,2,9.93-1.79,9.93-1.79.55.07,6.22,3.41,10.43-1.66,0,0,3.49,3,6.58.85A5,5,0,0,0,261.92,100.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.14,112.53s3.41-6.81,6.44-5.68,1.09,10.56-2,12.27a3.38,3.38,0,0,1-4.75-1.14Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,109.54c.05,0,.07.06,0,.09-2.17,1.27-3.07,3.59-3.6,5.93a1.87,1.87,0,0,1,2.69-.91c.07,0,0,.14,0,.13a2.08,2.08,0,0,0-2.16,1,9.82,9.82,0,0,0-.82,2c-.08.23-.47.17-.42-.08v0C260.16,114.75,261.84,110.3,265,109.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.71 126.18 257.93 123.69 263.04 117.66 262.11 116.87 257.2 122.67 251.26 125.05 251.71 126.18",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.39,125.22c-.55-1.81-5.59-1.28-4.75,1.46S253,127,252.39,125.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.68,106.67s.93-10.06-1.87-15.69c-3.13-6.27-16.59-12.51-26.07-6.1,0,0,15.24-2.32,22.07,6.44,2.88,3.69,2.5,15.53,2.5,15.53Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 264.26,
    cy: 111.81,
    rx: 9.3,
    ry: 8.16,
    transform: "translate(143.04 371.88) rotate(-87.94)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.5,111.31c-.17,4.61,3,8.47,7,8.61s7.47-3.47,7.63-8.08-3-8.47-7-8.62S258.66,106.7,258.5,111.31Z",
    style: {
      fill: "#054B8B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.55,141.08a87.88,87.88,0,0,1-6.58,7.31c-2.25,2.1-5,4-8,4.3s-6-.28-7.11-3.92c-.9-2.89-.78-5.87-.3-9.59a.11.11,0,1,0-.22,0c-.64,4.78-1.28,12.19,3.07,13.8,4.88,1.81,9.62-.74,13-4.12a45.8,45.8,0,0,0,6.26-7.67C264.67,141.1,264.59,141,264.55,141.08Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-94"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200.68,
    y: 250.56,
    width: 88.93,
    height: 3.99,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.57 250.56 273.62 254.55 200.68 254.55 200.68 250.56 270.57 250.56",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.77 254.55 180.1 254.55 172.89 195.69 259.56 195.69 266.77 254.55",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.11,225.12a5.17,5.17,0,0,1-5.19,5.27,5.38,5.38,0,0,1-5.36-5.27,5.15,5.15,0,0,1,5.18-5.28A5.4,5.4,0,0,1,225.11,225.12Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-94"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 373.51,
    y: 262.33,
    width: 92.72,
    height: 11.88,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.12,
    y: 274.21,
    width: 87.49,
    height: 3.71,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.62,
    y: 364.54,
    width: 62.5,
    height: 3.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.59 419.08 381.96 419.08 381.96 277.92 394.59 277.92 386.59 419.08",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.59 277.92 394.12 286.27 381.96 286.27 381.96 277.92 394.59 277.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "453.14 419.08 457.78 419.08 457.78 277.92 445.14 277.92 453.14 419.08",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "445.14 277.92 445.62 286.27 457.77 286.27 457.77 277.92 445.14 277.92",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-94"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 376.12,
    y: 232.71,
    width: 71.46,
    height: 12.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.34,
    y: 232.71,
    width: 6.66,
    height: 12.18,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.7,
    y: 232.71,
    width: 6.66,
    height: 12.18,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.75,
    y: 244.89,
    width: 78.42,
    height: 17.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.85,
    y: 246.69,
    width: 36.31,
    height: 13.83,
    transform: "translate(880 507.21) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.16,249.54c-4.88-.1-18.16-.27-18.16-.27l-3.52.06q-7.32.06-14.63.21,7.32.15,14.63.2l3.52.06S453.28,249.63,458.16,249.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.16,252.25c-4.88-.1-18.16-.27-18.16-.27l-3.52.06q-7.32.06-14.63.21,7.32.15,14.63.2l3.52.07S453.28,252.35,458.16,252.25Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.16,255c-4.88-.1-18.16-.26-18.16-.26l-3.52.06q-7.32,0-14.63.2,7.32.15,14.63.21l3.52.06S453.28,255.06,458.16,255Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.16,257.68c-4.88-.1-18.16-.27-18.16-.27l-3.52.06q-7.32.06-14.63.21,7.32.13,14.63.2l3.52.06S453.28,257.77,458.16,257.68Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.61,256v-4.13a.38.38,0,0,1,.38-.39h2.29a.39.39,0,1,1,0,.78h-1.89v1.28H388a.4.4,0,0,1,.38.39.38.38,0,0,1-.38.39h-1.63v1.29h1.89a.39.39,0,1,1,0,.78H386A.39.39,0,0,1,385.61,256Z",
    style: {
      fill: "#054B8B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.53,256a.4.4,0,0,1-.38.39.39.39,0,0,1-.38-.39v-4.07h0a.4.4,0,0,1,.15-.33.38.38,0,0,1,.53.09l2.27,3.13v-2.89a.38.38,0,0,1,.37-.38.4.4,0,0,1,.39.38V256a.4.4,0,0,1-.39.39.38.38,0,0,1-.28-.14l0,0-2.24-3.11Z",
    style: {
      fill: "#054B8B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.59,253.85a2.55,2.55,0,0,1,2.58-2.53,2.6,2.6,0,0,1,1.6.55.4.4,0,1,1-.49.63,1.84,1.84,0,0,0-1.11-.38,1.76,1.76,0,0,0-1.26.51,1.69,1.69,0,0,0-.52,1.22,1.66,1.66,0,0,0,.52,1.21,1.76,1.76,0,0,0,1.26.51,2,2,0,0,0,1-.27v-1h-1a.41.41,0,0,1-.4-.4.4.4,0,0,1,.4-.39h1.4a.39.39,0,0,1,.4.39v1.55a.43.43,0,0,1,0,.12.06.06,0,0,0,0,0h0a.32.32,0,0,1-.14.17,2.59,2.59,0,0,1-1.59.55A2.55,2.55,0,0,1,394.59,253.85Z",
    style: {
      fill: "#054B8B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.15,256v-4.13a.39.39,0,1,1,.78,0v3.74h1.9a.39.39,0,1,1,0,.78h-2.29A.39.39,0,0,1,400.15,256Z",
    style: {
      fill: "#054B8B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.18,251.85a.38.38,0,0,1,.39-.39.4.4,0,0,1,.39.39V256a.4.4,0,0,1-.39.39.38.38,0,0,1-.39-.39Z",
    style: {
      fill: "#054B8B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.11,255.15a.36.36,0,0,1,.51-.05,2.28,2.28,0,0,0,1.34.54,1.56,1.56,0,0,0,.88-.26.62.62,0,0,0,.3-.5.35.35,0,0,0-.07-.23.59.59,0,0,0-.21-.21,2.86,2.86,0,0,0-1-.33h0a3.39,3.39,0,0,1-.9-.27,1.46,1.46,0,0,1-.65-.55,1,1,0,0,1-.16-.57,1.27,1.27,0,0,1,.55-1,2.08,2.08,0,0,1,1.22-.38,2.64,2.64,0,0,1,1.52.57.35.35,0,0,1,.1.49.36.36,0,0,1-.5.11A2,2,0,0,0,408,252a1.35,1.35,0,0,0-.79.24.54.54,0,0,0-.26.44.29.29,0,0,0,.05.19.62.62,0,0,0,.18.19,2.85,2.85,0,0,0,.88.31h0a4.26,4.26,0,0,1,1,.29,1.6,1.6,0,0,1,.7.58,1.11,1.11,0,0,1,.17.6,1.35,1.35,0,0,1-.6,1.08,2.23,2.23,0,0,1-1.3.4,3,3,0,0,1-1.79-.7A.37.37,0,0,1,406.11,255.15Z",
    style: {
      fill: "#054B8B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.94,256v-4.13a.38.38,0,0,1,.38-.39.38.38,0,0,1,.39.39v1.68h1.82v-1.68a.38.38,0,0,1,.38-.39.38.38,0,0,1,.39.39V256a.38.38,0,0,1-.39.39.38.38,0,0,1-.38-.39V254.3h-1.82V256a.38.38,0,0,1-.39.39A.38.38,0,0,1,410.94,256Z",
    style: {
      fill: "#054B8B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.88,
    y: 223.41,
    width: 70.3,
    height: 9.3,
    style: {
      fill: "#054B8B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.87,
    y: 224.38,
    width: 47.17,
    height: 7.37,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.93,230.23q5.51.06,11,.08l11,0,11,0q5.52,0,11-.08c-3.67,0-7.35-.06-11-.08l-11,0-11,0C397.28,230.17,393.6,230.19,389.93,230.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.93,228.79c3.67,0,7.35.06,11,.07l11,0,11,0c3.68,0,7.36,0,11-.07q-5.51-.06-11-.08l-11,0-11,0Q395.44,228.73,389.93,228.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.93,227.34c3.67,0,7.35.06,11,.08l11,0,11,0c3.68,0,7.36,0,11-.08q-5.51-.06-11-.08l-11,0-11,0Q395.44,227.28,389.93,227.34Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.93,225.89q5.51.06,11,.08l11,0,11,0q5.52,0,11-.08c-3.67,0-7.35-.06-11-.08l-11,0-11,0C397.28,225.83,393.6,225.85,389.93,225.89Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.92,230.21v-4.13c0-.21.12-.39.27-.39h1.58c.14,0,.27.18.27.39s-.13.39-.27.39h-1.31v1.28h1.13c.14,0,.26.18.26.39s-.12.39-.26.39h-1.13v1.68c0,.21-.12.39-.27.39S436.92,230.42,436.92,230.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.09,230a.44.44,0,0,1-.17.49.24.24,0,0,1-.11,0h0a.3.3,0,0,1-.19-.08.77.77,0,0,1-.16-.25,2.85,2.85,0,0,1-.1-.84.81.81,0,0,0-.05-.3.5.5,0,0,0-.15-.2.74.74,0,0,0-.27-.17h-.57v1.52c0,.21-.12.39-.27.39s-.27-.18-.27-.39v-4.13c0-.22.12-.39.27-.39h.86c.58,0,1,.67,1,1.51a1.82,1.82,0,0,1-.38,1.15,1.06,1.06,0,0,1,.17.26,1.7,1.7,0,0,1,.16.75,3.32,3.32,0,0,0,0,.42A.32.32,0,0,1,442.09,230Zm-.68-2.81c0-.41-.22-.73-.5-.73h-.59v1.44h.59C441.19,227.91,441.41,227.59,441.41,227.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.87,230.21v-4.13c0-.22.12-.39.27-.39h1.58c.14,0,.27.17.27.39s-.13.39-.27.39h-1.31v1.28h1.13c.14,0,.26.18.26.39s-.12.39-.26.39h-1.13v1.29h1.31c.14,0,.27.17.27.39s-.13.39-.27.39h-1.58C443,230.6,442.87,230.42,442.87,230.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.27,230.21c0,.21-.12.39-.26.39s-.26-.18-.26-.39v-4.07h0a.44.44,0,0,1,.1-.32.22.22,0,0,1,.37.09l1.56,3.13v-2.89c0-.2.12-.38.27-.38s.26.18.26.38v4.07c0,.21-.12.39-.26.39a.25.25,0,0,1-.2-.14l0-.05-1.55-3.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.32,228.07c0-1.38.81-2.51,1.78-2.52a1.53,1.53,0,0,1,1.12.55.56.56,0,0,1,0,.56.23.23,0,0,1-.38.08,1,1,0,0,0-.78-.39,1.12,1.12,0,0,0-.87.51,2.23,2.23,0,0,0,0,2.43,1.12,1.12,0,0,0,.87.51,1,1,0,0,0,.78-.39.23.23,0,0,1,.38.08.56.56,0,0,1,0,.56,1.53,1.53,0,0,1-1.12.55C450.13,230.6,449.33,229.47,449.32,228.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.2,230.21v-4.13c0-.22.12-.39.27-.39s.27.17.27.39v1.68H455v-1.68c0-.22.12-.39.27-.39s.27.17.27.39v4.13c0,.22-.12.39-.27.39s-.27-.17-.27-.39v-1.68h-1.25v1.68c0,.22-.12.39-.27.39S453.2,230.43,453.2,230.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.08,240.8v-4.14a.38.38,0,0,1,.39-.38h.82a2.45,2.45,0,1,1,0,4.9h-.82A.38.38,0,0,1,391.08,240.8Zm.78-.4h.43a1.67,1.67,0,1,0,0-3.34h-.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.81,236.66a.38.38,0,0,1,.39-.38.39.39,0,0,1,.39.38v4.14a.39.39,0,0,1-.39.38.38.38,0,0,1-.39-.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.68,238.66a2.57,2.57,0,0,1,2.57-2.52,2.63,2.63,0,0,1,1.62.54.41.41,0,0,1,.07.56.4.4,0,0,1-.56.08,1.75,1.75,0,0,0-1.13-.38,1.85,1.85,0,0,0-1.26.5,1.74,1.74,0,0,0-.51,1.22,1.72,1.72,0,0,0,.51,1.22,1.85,1.85,0,0,0,1.26.5,1.75,1.75,0,0,0,1.13-.38.43.43,0,0,1,.56.07.41.41,0,0,1-.07.56,2.59,2.59,0,0,1-4.19-2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.29,237.06h-1.11v3.74a.38.38,0,0,1-.38.38.39.39,0,0,1-.39-.38v-3.74H403.3a.4.4,0,0,1-.38-.4.38.38,0,0,1,.38-.38h3a.39.39,0,0,1,.39.38A.41.41,0,0,1,406.29,237.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.88,236.66a.38.38,0,0,1,.39-.38.39.39,0,0,1,.39.38v4.14a.39.39,0,0,1-.39.38.38.38,0,0,1-.39-.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.83,236.89a2.56,2.56,0,0,1,0,3.54,2.27,2.27,0,0,1-1.67.75,2.36,2.36,0,0,1-1.72-.75,2.62,2.62,0,0,1,0-3.54,2.36,2.36,0,0,1,1.72-.75A2.27,2.27,0,0,1,413.83,236.89Zm-.09,1.77a1.85,1.85,0,0,0-.47-1.23,1.54,1.54,0,0,0-1.11-.49,1.56,1.56,0,0,0-1.14.49,1.8,1.8,0,0,0-.47,1.23,1.76,1.76,0,0,0,.47,1.22,1.52,1.52,0,0,0,2.25,0A1.81,1.81,0,0,0,413.74,238.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.51,240.8a.39.39,0,0,1-.38.38.38.38,0,0,1-.39-.38v-4.07h0a.38.38,0,0,1,.16-.32.38.38,0,0,1,.53.08l2.26,3.13v-2.88a.38.38,0,1,1,.76,0v4.07a.38.38,0,0,1-.38.38.4.4,0,0,1-.29-.14l0,0-2.24-3.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.63,240h-1.7l-.34.92a.4.4,0,0,1-.37.24l-.13,0a.4.4,0,0,1-.23-.51l1.55-4.12a.4.4,0,0,1,.74,0l1.55,4.12a.4.4,0,0,1-.23.51l-.14,0a.37.37,0,0,1-.35-.24Zm-.28-.77-.57-1.5-.57,1.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.9,240.6a.39.39,0,0,1-.25.49l-.15,0h0a.45.45,0,0,1-.27-.08.66.66,0,0,1-.23-.24,2,2,0,0,1-.14-.84.56.56,0,0,0-.09-.3.6.6,0,0,0-.21-.21,1.32,1.32,0,0,0-.39-.16h-.83v1.52a.39.39,0,0,1-.77,0v-4.14a.38.38,0,0,1,.38-.38h1.26a1.5,1.5,0,0,1,.95,2.65,1.2,1.2,0,0,1,.24.26,1.32,1.32,0,0,1,.23.76,2.62,2.62,0,0,0,0,.41A.42.42,0,0,1,428.9,240.6Zm-1-2.82a.72.72,0,0,0-.72-.72h-.87v1.44h.87A.72.72,0,0,0,427.92,237.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.27,236.94l-1.44,2v1.9a.38.38,0,0,1-.39.38.39.39,0,0,1-.38-.38v-1.9l-1.42-2a.37.37,0,0,1,.07-.54.38.38,0,0,1,.54.09l1.19,1.64,1.2-1.64a.39.39,0,0,1,.54-.09A.41.41,0,0,1,433.27,236.94Z",
    style: {
      fill: "#ebebeb"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearninglanguagesCuate);
export default __webpack_public_path__ + "static/media/Learning languages-cuate.68a78410c31a066df53302f76f5f979a.svg";
export { ForwardRef as ReactComponent };